import React, { PureComponent } from 'react'
import { withRouter } from 'react-router-dom'

import { LayoutDashboard } from 'Components/Layout/Dashboard/index'
import { UserManagementLegacyWrapper } from '../../Components/UserManagement/UserManagementWrapper/UserManagementWrapperLegacy'

import { HideWhenBlocked } from 'Containers/UIBlock/HideWhenBlocked'

import UserManagementIcon from 'Assets/Images/icons/userManagement'
import {
  getUsers,
  setFilterClient,
  setFilterStatus,
  setFilterRole,
  setUsersSortBy,
} from 'Reducers/Users/actions'
import { getClients } from 'Reducers/Clients/actions'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import { deleteUser } from '../../Reducers/Users/actions'
import { showReduxModal } from '../../Reducers/UI/actions'
import UsersListTableLegacy from './UserListTableLegacy'
import SubmitButton from 'Components/Form/SubmitButton'
import { PageTitle } from '../../Components/PageTitle/index'
import StyledBreadcrumbs from '../../Components/StyledBreadcrumbs'

class UserManagementLegacy extends PureComponent {
  componentDidMount() {
    this.props.getUsers()
    this.props.getClients()
  }

  deleteUserById = async id => {
    await this.props.deleteUser(id)
    this.props.getUsers()
    this.props.getClients()
  }

  deleteUserByIdConfirmation = id => {
    const user = this.props.usersList.find(u => u.id === id)

    this.props.showReduxModal({
      title: 'Confirmation needed',
      onConfirm: () => this.deleteUserById(id),
      children: `Are you sure you want to delete ${user.firstName} ${
        user.lastName
      }?`,
      confirmLabel: `Confirm`,
    })
  }

  render() {
    const { usersList, match, history } = this.props

    return (
      <HideWhenBlocked>
        <UserManagementLegacyWrapper>
          <LayoutDashboard>{this.renderBreadcrumbs()}</LayoutDashboard>
          <div className="user-container">
            <PageTitle>User Management</PageTitle>
            <div>{this.renderAddUser()}</div>
          </div>
          <UsersListTableLegacy
            match={match}
            usersList={usersList}
            history={history}
            handleUserDelete={this.deleteUserByIdConfirmation}
          />
          {/* {this.renderUsersTable()} */}
        </UserManagementLegacyWrapper>
      </HideWhenBlocked>
    )
  }

  /**
   * Renders add new user button
   * @returns JSX.Element[]
   */
  renderAddUser() {
    return (
      <SubmitButton
        value="Add User"
        className="add-user"
        onClick={() =>
          this.props.history.push(`${this.props.match.url}/create`)
        }
      />
    )
  }

  /**
   * Renders breadcrumbs
   * @return JSX.Element[]
   */
  renderBreadcrumbs() {
    return (
      <div className="breadcrumbs">
        <StyledBreadcrumbs
          icon={<UserManagementIcon style={{ width: 20 }} />}
          breadcrumbs={[
            {
              label: 'User Management',
            },
          ]}
        />
      </div>
    )
  }
}

UserManagementLegacy.propTypes = {
  usersList: PropTypes.array,
  getUsers: PropTypes.func.isRequired,
  getClients: PropTypes.func.isRequired,
  setFilterClient: PropTypes.func.isRequired,
  setFilterStatus: PropTypes.func.isRequired,
  setFilterRole: PropTypes.func.isRequired,
  filterClient: PropTypes.string,
  filterStatus: PropTypes.string,

  setUsersSortBy: PropTypes.func.isRequired,
}

const mapStateToProps = state => ({
  usersList: state.users.users,
  clientsList: state.clients.clientsList,
  filterClient: state.users.filterClient,
  filterStatus: state.users.filterStatus,
  filterRole: state.users.filterRole,
  sortBy: state.users.usersSortBy,
})

export default connect(
  mapStateToProps,
  {
    getUsers,
    getClients,
    setFilterClient,
    setFilterStatus,
    setFilterRole,
    setUsersSortBy,
    deleteUser,
    showReduxModal,
  },
)(withRouter(UserManagementLegacy))
